import React, { useState, useEffect } from "react";
import "./Vision.css";
import AboutCard from "../../../../UI/About-Card/AboutCard";
import { useLocation } from "react-router-dom";
import AuthModal from "../../../Membership/AuthModal/AuthModal";

export default function Vision({ withPageMargin = false }) {
  const location = useLocation();
  const [authView, setAuthView] = useState("login");
  const VALID_TABS = ["vision", "mission", "code"];
  const [activeTab, setActiveTab] = useState("vision");

  // 🔹 Handle tab opening from dropdown / URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const tab = params.get("visionTab");

    if (tab && VALID_TABS.includes(tab)) {
      setActiveTab(tab);
    }
  }, [location.search]);
  const [showAuth, setShowAuth] = useState(false);
  return (
    <section id="vision" className="vision-section">
      <div
        className={`vision-container ${withPageMargin ? "page-with-margin page-content" : ""
          }`}
      >
        <div className="content-box">

          {/* Tabs Navigation */}
          <div className="vision-tab-container mb-2">

            {["vision", "mission", "code"].map(
              (tab) => (
                <button
                  key={tab}
                  className={`vision-tab-btn ${activeTab === tab ? "active" : ""}`}
                  onClick={() => setActiveTab(tab)}
                >
                  {tab.replace(/^\w/, (c) => c.toUpperCase())}
                </button>
              )
            )}


          </div>

          <div className="tab-content-area px-5 pb-5">
            {/* Vision Tab */}
            {activeTab === "vision" && (
              <div className="vision-tab-pane-content fade-in">
                <p>
                  IHN is built on the foundation of symbiotic connectivity,
                  transforming traditional networking into lasting, high-value
                  relationships. We are a community dedicated to more than just
                  business; we care, share, and collaborate through a curated IHN
                  Calendar of Events—ranging from strategic networking and
                  social gatherings to bespoke excursions and customized travel.
                </p>
                <p>
                  We believe that a cohesive industry voice grants us global
                  credibility while accelerating growth within our domestic
                  markets. Through our flagship IHN KONNECT show, we provide a
                  cutting-edge, curated platform for precise buyer-seller
                  interaction. Our members are the "gold dust" of our ecosystem,
                  and we are committed to evolving our offerings to ensure
                  constant Member Delight. Guided by our Board of Advisors, we
                  empower the IHN family through strategic ideation, personality
                  development, and value creation for both individual and
                  corporate success.
                </p>
                <button
                  className="join-now mt-5"
                  onClick={() => setShowAuth(true)}>

                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path>
                  </svg>
                  <span className="text-light">Join Now</span>

                </button>
              </div>
            )}

            {/* Mission Tab */}
            {activeTab === "mission" && (
              <div className="vision-tab-pane-content fade-in">
                <p>
                  Launched in January 2021, IHN emerged at a global turning point.
                  As the pandemic reshaped economies and lives, it laid bare the
                  true weight of human aspirations and the necessity for
                  connection. In that era of disruption, we embraced vital
                  lessons: how to maximize potential, operate with agility, and
                  foster relationships even when the world was virtual. From
                  these challenges, a new skill set was forged—and IHN was born.
                </p>
                <p>
                  Today, IHN stands as a premier private networking platform,
                  providing concierge-level connectivity across the travel,
                  tourism, events, and hospitality sectors. Our service is
                  proactive, personalized, and swift. Beyond our signature
                  networking events, we empower members through the
                  #MeetingGenie format—a specialized service designed to
                  facilitate #DreamConnects with key industry figures both
                  within and beyond our network. Our mission is to build
                  unbreakable linkages and #synergies across the vast hospitality
                  landscape, including Aviation, Entertainment, Weddings, and
                  beyond.
                </p>
                     <button
                  className="join-now mt-5"
                  onClick={() => setShowAuth(true)}>

                  <svg height="24" width="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 13c0-5.088 2.903-9.436 7-11.182C16.097 3.564 19 7.912 19 13c0 .823-.076 1.626-.22 2.403l1.94 1.832a.5.5 0 0 1 .095.603l-2.495 4.575a.5.5 0 0 1-.793.114l-2.234-2.234a1 1 0 0 0-.707-.293H9.414a1 1 0 0 0-.707.293l-2.234 2.234a.5.5 0 0 1-.793-.114l-2.495-4.575a.5.5 0 0 1 .095-.603l1.94-1.832C5.077 14.626 5 13.823 5 13zm1.476 6.696l.817-.817A3 3 0 0 1 9.414 18h5.172a3 3 0 0 1 2.121.879l.817.817.982-1.8-1.1-1.04a2 2 0 0 1-.593-1.82c.124-.664.187-1.345.187-2.036 0-3.87-1.995-7.3-5-8.96C8.995 5.7 7 9.13 7 13c0 .691.063 1.372.187 2.037a2 2 0 0 1-.593 1.82l-1.1 1.039.982 1.8zM12 13a2 2 0 1 1 0-4 2 2 0 0 1 0 4z" fill="currentColor"></path>
                  </svg>
                  <span className="text-light">Join Now</span>

                </button>
              </div>
            )}

            {/* Code / Stats Tab */}
            {activeTab === "code" && <AboutCard />}
          </div>
        </div>
      </div>
      <AuthModal
        isOpen={showAuth}
        onClose={() => setShowAuth(false)}
      />
    </section>
  );
}
